module.exports = "/images/lena.jpg?4e95f173d5cfe4088935bd593b148c84";